import { useAgentsAccess } from '@/hooks/use-agents-access.hook';
import { useAppSelector } from '@/store';
import { selectAiChatContext } from '@/store/features/ui.feature';

/**
 * True where Clu's chat takes Gumloop's agent chat style: the user message
 * cards, the assistant header, the steps line, the question card folding into
 * the steps, and the composer.
 *
 * It is the agents redesign's look: an agent's workspace always, and Clu
 * everywhere else (the side panel, the full screen chat) for organizations
 * past the AppSumo fence (`chatLookUnlocked`). AppSumo-only organizations
 * keep the old chat. What belongs to an agent alone (its
 * name on the answers, its home and guided screen, the panel beside the chat)
 * checks the agent context itself, not this.
 */
export function useGumloopChat(): boolean {
  const inAgent = useAppSelector(
    (state) => selectAiChatContext(state)?.type === 'agent'
  );
  const { unlocked, chatLookUnlocked } = useAgentsAccess();
  return inAgent || (chatLookUnlocked ?? unlocked);
}
